export default function ArticleText({part}) {
	if (!part)return null;

	if (part.style && part.style.background) {
		part.style = {padding: '30px',...part.style};
	}
	return(
		<div className={'articleParagraph'} style={part.style?part.style:null} dangerouslySetInnerHTML={{__html: part.value}}></div>
	)
}